var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacilities1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c9c9c9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m5.2,10.43c-.05-4.03,3.35-8.24,8.16-9.08,5.24-.91,10.33,2.63,11.27,7.87.5,2.79-.09,5.35-1.78,7.63-1.7,2.3-3.43,4.59-5.16,6.87-1.42,1.88-3.98,1.87-5.4-.01-1.71-2.27-3.41-4.54-5.11-6.81-1.31-1.75-1.98-3.71-1.98-6.48Zm17.74.31c-.03-.27-.04-.73-.13-1.19-.8-4.41-4.93-7.25-9.35-6.41-3.49.66-6.4,3.73-6.39,7.82,0,1.72.54,3.29,1.58,4.68,1.8,2.39,3.59,4.78,5.39,7.17.55.73,1.37.74,1.92,0,1.8-2.4,3.61-4.79,5.41-7.2,1.04-1.39,1.54-2.96,1.57-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.99,14.27c-1.82,0-3.27-1.45-3.27-3.27,0-1.83,1.45-3.27,3.3-3.27,1.82,0,3.26,1.46,3.26,3.28,0,1.82-1.46,3.26-3.28,3.26Zm.07-4.84c-.82-.06-1.58.65-1.63,1.51-.06.81.65,1.57,1.51,1.63.81.06,1.58-.65,1.63-1.51.05-.81-.65-1.57-1.51-1.63Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m18.65,28.67h-7.3c-.5,0-.9-.4-.9-.9s.4-.9.9-.9h7.3c.5,0,.9.4.9.9s-.4.9-.9.9Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilities1);
export default __webpack_public_path__ + "static/media/facilities-1.5c999da319189bfb275350ee7179c6b7.svg";
export { ForwardRef as ReactComponent };